export function parseBookingDate(value) {
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : new Date(value);
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(year, month - 1, day, 12);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
}
export function formatBookingDate(value) {
  const date = value instanceof Date ? value : parseBookingDate(value);
  if (!date || Number.isNaN(date.getTime())) throw new Error('Please select a valid date.');
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
export function addBookingDays(value, days) {
  const date = new Date(value);
  date.setDate(date.getDate() + days);
  return date;
}
export function bookingNights(checkin, checkout) {
  const start = parseBookingDate(checkin);
  const end = parseBookingDate(checkout);
  if (!start || !end) return 0;
  return (Date.UTC(end.getFullYear(), end.getMonth(), end.getDate()) -
    Date.UTC(start.getFullYear(), start.getMonth(), start.getDate())) / 86400000;
}
export function validateBookingDates(checkin, checkout) {
  const start = parseBookingDate(checkin);
  const end = parseBookingDate(checkout);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (!start || !end || start < today || bookingNights(start, end) < 1) {
    throw new Error('Select a check-in date today or later and a check-out date after check-in.');
  }
  return { checkin: start, checkout: end };
}
